import { __assign, __awaiter, __generator } from "tslib";
import { merge } from 'lodash';
import { defaultCategoryList } from './categoryList';
import { ImageResizeMode } from './imageResizeMode';
var BASE_API_URL = '/_api/app-settings-service';
export var API_URL_SETTINGS_INSTANCES = "".concat(BASE_API_URL, "/v1/settings/instances");
export var defaultAppSettings = {
    categoryList: defaultCategoryList,
    productImageResizeMode: ImageResizeMode.Fit,
    isProductPriceVisible: true,
    isSeoHiddenIncluded: false,
};
export var createSettingsClient = function (_a) {
    var httpClient = _a.httpClient;
    var getDefault = function () { return (__assign({}, defaultAppSettings)); };
    var get = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpClient.get(API_URL_SETTINGS_INSTANCES, {
                            params: {
                                state: state,
                                host: 'VIEWER',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, merge({}, getDefault(), data.settings)];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, getDefault()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var set = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, httpClient.patch(API_URL_SETTINGS_INSTANCES, {
                        settings: (_a = {}, _a[key] = value, _a),
                        host: 'VIEWER',
                        states: ['SAVED'],
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        getSaved: function () { return get('SAVED'); },
        getPublished: function () { return get('PUBLISHED'); },
        getDefault: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, getDefault()];
        }); }); },
        set: set,
    };
};
//# sourceMappingURL=settingsClient.js.map